import { Action } from '@ngrx/store'
import * as UsersTypes from './users.types'
import { User } from './users.interface'

// Fetch Roles Actions
export class FetchRolesRequest implements Action {
  readonly type = UsersTypes.FETCH_ROLES_REQUEST
  constructor() {}
}

export class FetchRolesSuccess implements Action {
  readonly type = UsersTypes.FETCH_ROLES_SUCCESS
  constructor(public payload: any) {}
}

export class FetchRolesFailure implements Action {
  readonly type = UsersTypes.FETCH_ROLES_FAILURE
  constructor(public payload: any) {}
}

// Fetch Users Actions
export class FetchUsersRequest implements Action {
  readonly type = UsersTypes.FETCH_USERS_REQUEST
  constructor(public payload: any) {}
}

export class FetchUsersSuccess implements Action {
  readonly type = UsersTypes.FETCH_USERS_SUCCESS
  constructor(
    public payload: User[],
    public total: number,
    public filtered: number,
  ) {}
}

export class FetchUsersFailure implements Action {
  readonly type = UsersTypes.FETCH_USERS_FAILURE
  constructor(public payload: any) {}
}

// Fetch User Actions
export class FetchUserRequest implements Action {
  readonly type = UsersTypes.FETCH_USER_REQUEST
  constructor(public id: number, public property: string) {}
}

export class FetchUserSuccess implements Action {
  readonly type = UsersTypes.FETCH_USER_SUCCESS
  constructor(public payload: User, public property: string) {}
}

export class FetchUserFailure implements Action {
  readonly type = UsersTypes.FETCH_USER_FAILURE
  constructor(public payload: any, public property: string) {}
}

// Delete User Actions
export class DeleteUserRequest implements Action {
  readonly type = UsersTypes.DELETE_USER_REQUEST
  constructor(public id: number) {}
}

export class DeleteUserSuccess implements Action {
  readonly type = UsersTypes.DELETE_USER_SUCCESS
  constructor() {}
}

export class DeleteUserFailure implements Action {
  readonly type = UsersTypes.DELETE_USER_FAILURE
  constructor(public payload: any) {}
}

// Create User Actions
export class CreateUserRequest implements Action {
  readonly type = UsersTypes.CREATE_USER_REQUEST
  constructor(public payload) {}
}

export class CreateUserSuccess implements Action {
  readonly type = UsersTypes.CREATE_USER_SUCCESS
  constructor() {}
}

export class CreateUserFailure implements Action {
  readonly type = UsersTypes.CREATE_USER_FAILURE
  constructor(public payload: any) {}
}

// Update User Actions
export class UpdateUserRequest implements Action {
  readonly type = UsersTypes.UPDATE_USER_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateUserSuccess implements Action {
  readonly type = UsersTypes.UPDATE_USER_SUCCESS
  constructor() {}
}

export class UpdateUserFailure implements Action {
  readonly type = UsersTypes.UPDATE_USER_FAILURE
  constructor(public payload: any) {}
}

// Update User Password Actions
export class UpdateUserPasswordRequest implements Action {
  readonly type = UsersTypes.UPDATE_USER_PASSWORD_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateUserPasswordSuccess implements Action {
  readonly type = UsersTypes.UPDATE_USER_PASSWORD_SUCCESS
  constructor() {}
}

export class UpdateUserPasswordFailure implements Action {
  readonly type = UsersTypes.UPDATE_USER_PASSWORD_FAILURE
  constructor(public payload: any) {}
}

// Common Actions
export class UpdateField implements Action {
  readonly type = UsersTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = UsersTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateUserRequest
  | UpdateUserSuccess
  | UpdateUserFailure
  | FetchUserSuccess
  | FetchUserFailure
  | FetchUserRequest
  | CreateUserRequest
  | CreateUserSuccess
  | CreateUserFailure
  | DeleteUserRequest
  | DeleteUserSuccess
  | DeleteUserFailure
  | FetchRolesRequest
  | FetchRolesSuccess
  | FetchRolesFailure
  | SetDefaultData
  | UpdateField
  | FetchUsersRequest
  | FetchUsersSuccess
  | FetchUsersFailure
  | UpdateUserPasswordRequest
  | UpdateUserPasswordSuccess
  | UpdateUserPasswordFailure
